import React, { useRef } from 'react';
import { Printer } from 'lucide-react';
import { useLanguage } from '../StoreContext/LanguageContext';

const LandObjectionRegister = ({ setSubComponent }) => {
  const documentRef = useRef(null);

  const { language, translations } = useLanguage();
  const handleObjectionButton = () => {
    setSubComponent("Akshep");
  };
  const handleObjectionReportButton = () => {
    setSubComponent("AkshepNirakaranPrasidhiAheval");
  };

  const handleObjectionlistButton = () => {
    setSubComponent("AkshepList");
  };


  const tableData = [
    {
      serial: "1",
      date: "१९/०६/२०२२",
      objector: "रमेश काहू काळे",
      objection: "नविन पुनर्वसित गावठाण पळशिफाटा यादीमध्ये नाव समाविष्ट करण्यात.",
      clarification: "अर्जदार रमेश काहू काळे यांचे नाव पुनर्वसित गावठाण पळशिफाटा चे यादीमध्ये समाविष्ट उसुन त्यांचे नाव नविन पुनर्वसित गावठाण पळशिफाटा यादीमध्ये समाविष्ट करण्यात येईल."
    },
    {
      serial: "२",
      date: "२०/०६/२०२२",
      objector: "संमाजी नारायण उगले",
      objection: "मौजे आडोळ टु.चे गोविन पुनर्वसन गावठाणामाठे फिरते धरकारच्या यादीमध्ये नाऊच्या नांचाचा रतानांश करण्यावत.",
      clarification: "कार्यकारी यशगणे सांतर केलेले कुटुंब सर्वेक्षण अहवालानुसार संमाजी नारायण उगले व त्यांचे पत्नी नाचे वस्तुलाबाई संमाजी उगले हे अनुज्ञने दिनांक २६/०४/२०२० व दिनांक १२/०६/२०१९ रोजी न्यायाधेश कलम ११(१) दिनांक १५/०६/२०१६ तात्तर स्थळ झालेले असल्यामुळे संमाजी नारायण उगले यांचे नाव खातेदार वर्गवारी १ ते ५ (स्टुंब २) समाविष्ट (नविन गावठाण पळशिफिली) करण्यात येईल."
    },
    {
      serial: "३",
      date: "२०/०६/२०२२",
      objector: "इंदुबाई विनायक उगले",
      objection: "मौजे आडोळ टु.अंधराल रहिवासी अर्जून घर क्र.५७५ हे रजिस्टर ऊरस्वादार वर्ग २००१ नंप्र दिलय धतले होतं स्यामगाणं नोंकरेला पुनर्वस्तः उल्लेजारी पत्रता: १/१/२०१६ रोजा मोठाराशी फित्तल लाछून करस्मेसा १ मेद्युस्त ८ दाटर त्यावर सुल्मों इत्यांदि भुमेंगीत केले स्यांमगाणं लाङल बलुस्ठुत लाला चुचेंठुक के तुपरों लाछून सांवा प्याऐन्हालेसि५०१४.नुसारमादान स्थुस्तात रक्तक थांऐकेवुन दिलं.: न्युबुक उगले रत्ने नाव उमालत त्तुर्मु नांद्ययल्त ठुत्रा सेथ्याऐ मत्रा सुत्या १००५ मेपयु राहुत अस्यून संधे आउ सुरत्या साऊ चाच १२६ अंधा बारिन्ञ्यानत्र टाङुनामक संयुम कार्यंदीरर कार्यंदर्ने व अंपर अंसनलाना",
      clarification: "अर्जदार इंदुबाई विनायक उगले यानची मुलङ तरकगाचे यादीमध्ये नमुकार दिलकार उगले यांचे पैकी पेरजो अर्जदाराचे नाव अर्थात सन्नाविष्ट करुन दाच्य अप्रष्य नमुकर केलला आहे.अर्जदाराची पानी नाचे विजयऊ रमेश उगले यांचे घर क्रमांक ५५१ कार्यस्त दुमालेले अस्यून करोसोत दिग्व क्र.८२८२८२लुठ उर्वादार इंदुबाई विनायक उगले यांचे नाव घटदा गावठाण पळशिफाटा यादीत समाविष्ट कयुना केषुन नो:तलाटुवुठ नमुकार दिलकार उगले यांचे कोत्तु अर्जदार विगर घर क्र.५७५ वर १००५ नंप्रे परेदी केनेस्त उल्ललमें नमुकार दिलकार उगले यांचे नैव मुदुङ ठाटप यादीमध्युन कमी करण्यात येईलदुरर अनुज्ञाष रोङ्ग्रा नुसारर युङानर टाङसदीळ फिन्मालें कायलाल लेथ आफे"
    },
    {
      serial: "४",
      date: "२८/०६/२०२२",
      objector: "संतोष कालीनाथ हिंदुस्तानर",
      objection: "नविन पुनर्वसन गावठाणामाठीले फिरते धारकांच्या यादीमध्ये भुक्तवाद दुरुस्ती करण्यावत.",
      clarification: "नविन गावठाण पळशिफाटर येथील भुङङ वाटुचं पार्च यादीमध्ये अर्जदारांणें नाव समाविष्ट भाथे परेत्तु धुन्वचाधान संतोष अधोऐ उगले सेपां नाव नमुकर अस्यान नायचे तुक झालेले आहे लंदर पुनचायी तुरुस्ती करयल अलिन स्थानीय हिंदुस्तानर आरे नाव करण्यात येईल."
    }
  ];

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Print Button */}
      <div className="flex justify-start mb-6 gap-2">

        <button
          onClick={handleObjectionButton}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
        >
          {translations[language]?.objection}
        </button>
        <button
          onClick={handleObjectionReportButton}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
        >
          {translations[language]?.objectionReport}
        </button>
        <button
          onClick={handleObjectionlistButton}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
        >
          {translations[language]?.objectionComments}
        </button>
      </div>
    </div>
  );
};

export default LandObjectionRegister;